/* Legacy Layers – cart drawer / cart page behaviour (upsell scroller + variant sync, delivery dates, wallet buttons) */
(function () {
  if (!customElements.get('ll-scroller')) {
    customElements.define('ll-scroller', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-scroller-track]');
        if (!this.track) return;
        this.querySelectorAll('[data-dir]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const item = this.track.querySelector('li');
            const step = item ? item.getBoundingClientRect().width + 10 : this.track.clientWidth * 0.8;
            this.track.scrollBy({ left: step * Number(btn.dataset.dir), behavior: 'smooth' });
          });
        });
        // dots (shown instead of the arrows on small screens): one per card, click to jump
        const items = [...this.track.querySelectorAll('li')];
        let dots = this.querySelector('.ll-upsell__dots');
        if (!dots && items.length > 1) {
          dots = document.createElement('div');
          dots.className = 'll-upsell__dots';
          items.forEach((li, i) => {
            const d = document.createElement('button');
            d.type = 'button'; d.className = 'll-upsell__dot'; d.setAttribute('aria-label', 'Item ' + (i + 1));
            d.addEventListener('click', () => this.track.scrollTo({ left: li.offsetLeft - this.track.offsetLeft, behavior: 'smooth' }));
            dots.appendChild(d);
          });
          this.appendChild(dots);
        }
        const sync = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.classList.toggle('at-start', this.track.scrollLeft <= 2);
          this.classList.toggle('at-end', this.track.scrollLeft >= max);
          this.classList.toggle('no-scroll', max <= 2);
          if (dots) {
            const x = this.track.scrollLeft + this.track.clientWidth / 2;
            let active = 0;
            items.forEach((li, i) => { if (li.offsetLeft - this.track.offsetLeft <= x) active = i; });
            dots.querySelectorAll('.ll-upsell__dot').forEach((d, i) => d.classList.toggle('is-active', i === active));
          }
        };
        this.track.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync, { passive: true });
        sync();
      }
    });
  }

  // ---- Recommended-for-you cards: colour swatch + size select -> variant id / price / availability / image
  function syncUpsell(item) {
    const script = item.querySelector('[data-ll-upsell-variants]');
    if (!script) return;
    let variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }
    const ci = Number(item.dataset.colorIdx), si = Number(item.dataset.sizeIdx);
    const color = item.querySelector('[data-ll-upsell-color]:checked');
    const size = item.querySelector('[data-ll-upsell-size]');
    const idInput = item.querySelector('[data-ll-upsell-id]');
    const price = item.querySelector('[data-ll-upsell-price]');
    const btn = item.querySelector('.ll-upsell__add');
    // sizes not sold in the chosen colour are disabled; if the current size is one of them, jump to the first available
    if (size && ci > -1 && color) {
      let firstOk = null;
      [...size.options].forEach((o) => {
        const ok = variants.some((v) => v.a && v.o[ci] === color.value && v.o[si] === o.value);
        o.disabled = !ok;
        if (ok && !firstOk) firstOk = o;
      });
      if (size.selectedOptions[0] && size.selectedOptions[0].disabled && firstOk) size.value = firstOk.value;
    }
    const match = variants.find((v) => (ci === -1 || !color || v.o[ci] === color.value) && (si === -1 || !size || v.o[si] === size.value));
    if (match) {
      idInput.value = match.id;
      if (price) price.textContent = match.p;
      const img = item.querySelector('.ll-upsell__img img');
      if (img && match.i && img.getAttribute('src') !== match.i) { img.removeAttribute('srcset'); img.src = match.i; }
      if (btn) { btn.toggleAttribute('disabled', !match.a); btn.classList.toggle('is-soldout', !match.a); }
    } else if (btn) {
      btn.setAttribute('disabled', ''); btn.classList.add('is-soldout');
    }
  }
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-ll-upsell-color], [data-ll-upsell-size]')) syncUpsell(e.target.closest('[data-ll-upsell]'));
  });
  const initUpsells = (root) => (root || document).querySelectorAll('[data-ll-upsell]').forEach(syncUpsell);

  // ---- Expected delivery window: N–M business days from today (settings in the snippet's data attributes)
  function fmt(d) { return ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2); }
  function biz(n) { const d = new Date(); let a = 0; while (a < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) a++; } return d; }
  function setDates(root) {
    (root || document).querySelectorAll('[data-ll-delivery]').forEach((el) => {
      const min = Number(el.dataset.minDays || 3), max = Number(el.dataset.maxDays || 7);
      const target = el.querySelector('[data-ll-delivery-dates]');
      const txt = fmt(biz(min)) + ' – ' + fmt(biz(max));
      if (target && target.textContent !== txt) target.textContent = txt;
    });
  }
  // ---- Recommended for you opens by default, matching the <details open> the Liquid renders.
  // It used to start collapsed under a 760px innerHeight to keep SECURE CHECKOUT on screen, which
  // meant it was always collapsed on a phone: iOS Safari reports ~660px of innerHeight on a 375x812
  // device once its chrome is subtracted. The drawer has since given that space back (wallets hidden
  // on mobile, Subtotal dropped when there is no discount), and the footer is pinned to the bottom
  // with the item list absorbing the slack, so the button stays put.
  // Dawn re-renders the drawer HTML (with <details open>) on every cart change, so the bands are put
  // back into their previous state synchronously inside the mutation observer - before the next paint -
  // which is what stops the open/close flash. The customer's own clicks on either header are remembered.
  let upsellUserChoice = null;
  let noteOpen = false;
  document.addEventListener('click', (e) => {
    if (!e.target.closest) return;
    const head = e.target.closest('.ll-upsell--drawer > .ll-upsell__head');
    if (head) upsellUserChoice = !head.parentElement.open;   // the toggle happens after this handler
    const noteHead = e.target.closest('.ll-cd__note > .ll-cd__note-head');
    if (noteHead) noteOpen = !noteHead.parentElement.open;
  });
  function applyBandState() {
    document.querySelectorAll('.ll-upsell--drawer').forEach((d) => {
      const want = upsellUserChoice !== null ? upsellUserChoice : true;
      if (d.open !== want) d.open = want;
    });
    const note = document.querySelector('#CartDrawer .ll-cd__note');
    if (note && note.open !== noteOpen) note.open = noteOpen;
  }
  const run = () => { setDates(); initUpsells(); applyBandState(); };
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  let pending = false;
  new MutationObserver((muts) => {
    if (!muts.some((m) => m.addedNodes.length && !(m.target.closest && m.target.closest('[data-ll-delivery]')))) return;
    applyBandState();
    if (pending) return;
    pending = true;
    setTimeout(() => { pending = false; setDates(); initUpsells(); }, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ---- Trash icon at quantity 1: remove the line instead of stepping to 0 (which trips Dawn's min-quantity error)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('cart-drawer-items .quantity__button[name="minus"], cart-items .quantity__button[name="minus"]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('.quantity__input');
    if (!input || Number(input.value) > 1) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const row = btn.closest('.cart-item');
    const remove = row && row.querySelector('cart-remove-button button, cart-remove-button');
    if (remove) remove.click();
  }, true);

  // ---- Express checkout buttons (Shop Pay / PayPal / Google & Apple Pay) are hydrated once by Shopify;
  // Dawn replaces the drawer's HTML on every cart change, so keep the hydrated node and put it back.
  // The same hook keeps the Recommended / Add Note bands in the state they were in, applied
  // synchronously (before the next paint) so the fresh <details open> markup never flashes.
  function preserveWallets(Cls) {
    if (!Cls || Cls.prototype.__llWallets) return;
    Cls.prototype.__llWallets = true;
    const orig = Cls.prototype.renderContents;
    Cls.prototype.renderContents = function (state) {
      const live = document.querySelector('#CartDrawer .ll-wallets');
      const keep = live && live.querySelector('iframe, button, [role="button"], shopify-accelerated-checkout-cart, shopify-accelerated-checkout') ? live : null;
      orig.call(this, state);
      if (keep) {
        const slot = document.querySelector('#CartDrawer .ll-wallets');
        if (slot && slot !== keep) slot.replaceWith(keep);
      }
      applyBandState();
    };
  }
  ['cart-drawer', 'cart-drawer-items'].forEach((n) => customElements.whenDefined(n).then(() => preserveWallets(customElements.get(n))));

  // ---- ?openCartDrawer=true opens the slide cart on arrival. snippets/ll-cart-redirect.liquid
  // sends /cart here, but the flag works on any URL, so a Klaviyo link can point straight at a
  // collection with the cart already open. The flag is taken back out of the address bar so a
  // refresh, a bookmark or a shared link doesn't pop the drawer again.
  (function () {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var flag = params.get('openCartDrawer');
    if (flag === null || flag === '0' || flag === 'false') return;
    params.delete('openCartDrawer');
    var qs = params.toString();
    try {
      history.replaceState(history.state, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    } catch (e) { /* non-fatal */ }
    var open = function () {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      // Hand it the header icon as the trigger so focus lands back there on close.
      drawer.open(document.querySelector('#cart-icon-bubble') || undefined);
    };
    // cart-drawer.js is deferred, so wait for the element to be defined as well as for the DOM.
    customElements.whenDefined('cart-drawer').then(function () {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', open, { once: true });
      else open();
    });
  })();

  // Cart page: an upsell "Add" opens the drawer; refresh the page items behind it once the add succeeds
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('.ll-upsell--page') || !window.subscribe || !window.PUB_SUB_EVENTS) return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => { if (e && e.source === 'product-form') setTimeout(() => window.location.reload(), 600); });
  });
})();
